module.exports = __webpack_public_path__ + "img/awards_image_14.fb6de74e.jpg";